import { SVGProps } from './types';

const BreadcrumbSlashIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth="1.667"
        d="M5.833 18.333l8.334-16.666"
      ></path>
    </svg>
  );
};

export { BreadcrumbSlashIcon };
